import { render, staticRenderFns } from "./TabelaSimples.vue?vue&type=template&id=f3f31c6a&"
import script from "./TabelaSimples.vue?vue&type=script&lang=js&"
export * from "./TabelaSimples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports